<div [class.hidden]="hidden">
  <div class="form-wrapper" [class.inline]="formInline">
    @if (label) {
      <ion-label [ngClass]="{ uppercase: uppercase }" class="ion-text-start">
        {{ label }}
      </ion-label>
    }
    <div class="input-wrapper" (focusout)="onTouched()">
      <ngx-intl-tel-input
        [cssClass]="disabled ? 'phone-input-disabled' : 'phone-input'"
        [class.error]="showError && control?.errors && control?.touched"
        [preferredCountries]="preferredCountries"
        [selectedCountryISO]="selectedCountry"
        [enableAutoCountrySelect]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [enablePlaceholder]="false"
        [selectFirstCountry]="false"
        [maxLength]="15"
        [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        [numberFormat]="PhoneNumberFormat.National"
        (keyup.enter)="keyenter.emit()"
        [formControl]="phoneControl"
        (keyup)="keyenter.emit()"
      ></ngx-intl-tel-input>
    </div>
  </div>
</div>

@if (showError && control?.errors && control?.touched) {
  <div
    class="error-wrapper"
    [class.absolute]="errorPlacement === 'absolute'"
    [class.inline]="inline"
    >
    @if (inline) {
      <div class="clear"></div>
    }
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
  </div>
}

@if (info) {
  <div class="info" [class.inline]="inline">
    @if (inline) {
      <div class="clear"></div>
    }
    <div>{{ info }}</div>
  </div>
}
